import { render } from "./market-switcher.vue?vue&type=template&id=3242cb9a"
import script from "./market-switcher.vue?vue&type=script&lang=js"
export * from "./market-switcher.vue?vue&type=script&lang=js"

import "./market-switcher.vue?vue&type=style&index=0&id=3242cb9a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__